export default{
    language:[
        {
            value:'zh',
            label:'中文'
        },
        {
            value:'en',
            label:'英文'
        },
    ]
    
}